import React, { useEffect, useState } from "react";
import TableList from "../../components/TableList/TableList";
import Pagination, {
  defaultPaginationConfig,
} from "../../components/reusable/Pagination/Pagination";
import PageLoader from "../../components/reusable/PageLoader/PageLoader";
import { dashboardAPI } from "../../Api/dashboardAPI";
import { toastError } from "../../utils/toast";
import "./Eventos.css";
import Button from "../../components/reusable/Button/Button";
import { useAppDispatch } from "../../app/store";
import { setLoadingPageScreen } from "../../features/Dashboard/Slices/dashboardSlice";
import ModalConfirmation from "../../components/reusable/ModalConfirmation/ModalConfirmation";
import xlsx from "json-as-xlsx";
import Input from "../../components/reusable/Input/Input";
import Selector from "../../components/reusable/Selector/Selector";
import DateTimePicker from "../../components/reusable/DateTimePicker/DateTimePicker";
import useAuth from "../../hooks/useAuth";
import moment from "moment";

const nivelEventosOptions = [
  { text: "INFO", value: "INFO" },
  { text: "WARNING", value: "WARNING" },
  { text: "ERROR", value: "ERROR" },
];

function Log() {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEvents, setTotalEventos] = useState(0);
  const [tiposEventos, setTiposEventos] = useState<any[]>([]);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [eventos, setEventos] = useState<any[]>([]);
  const [tipoEvento, setTipoEvento] = useState("");
  const [idTx, setIdTx] = useState("");
  const [componente, setComponente] = useState("");
  const [idCupo, setIdCupo] = useState<number | null>(null);
  const [idAlumnoPrograma, setIdAlumnoPrograma] = useState<number | null>(null);
  const [fechaDesde, setFechaDesde] = useState(() => {
    return moment().subtract(2, "hours").format("YYYY-MM-DDTHH:mm");
  });
  const [fechaHasta, setFechaHasta] = useState(() => {
    return moment().hour(23).minute(59).format("YYYY-MM-DDTHH:mm");
  });
  const [pageSize, setPageSize] = useState("100");
  const [descripcion, setDescripcion] = useState("");
  const { hasPermission } = useAuth();
  const dispatch = useAppDispatch();
  const [nivelEvento, setNivelEvento] = useState("");

  const limpiarFiltros = () => {
    setTipoEvento("");
    setNivelEvento("");
    setIdTx("");
    setComponente("");
    setIdCupo(null);
    setIdAlumnoPrograma(null);
    setFechaDesde("");
    setFechaHasta("");
    setPageSize("100");
    setDescripcion("");
  };

  const setLoading = (newState: boolean) => {
    dispatch(setLoadingPageScreen(newState));
  };

  const delEventos = async () => {
    await dashboardAPI.delEventos();
    getEventos();
    setShowDeleteConfirmation(false);
  };

  const exportEventos = async () => {
    try {
      // Enviar las fechas en el formato YYYY-MM-DDTHH:mm
      const data = await dashboardAPI.exportEventos(fechaDesde, fechaHasta);
      let settings = {
        fileName: "Eventos", // Name of the resulting spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
        writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
        RTL: false, // Display the columns from right-to-left (the default value is false)
      };
      console.log("data:", data);
      xlsx(data, settings);
    } catch (error: any) {
      console.log(`ERROR: ${error.message}`);
      toastError();
    }
  };

  const getTiposEventos = async () => {
    const data = await dashboardAPI.getTiposEventos();
    if (data.length > 0) {
      setTiposEventos(data.map((item) => ({ text: item, value: item })));
    }
  };

  const getEventos = async (newPage?: number) => {
    setLoading(true);
    try {
      if (tiposEventos.length === 0) {
        await getTiposEventos();
      }
      const page = newPage ? (newPage - 1) * Number(pageSize) : 0;
      const newData = await dashboardAPI.getEventosPaginated(
        Number(pageSize),
        page,
        tipoEvento.length > 0 ? tipoEvento : null,
        idTx.length > 0 ? Number(idTx) : null,
        componente.length > 0 ? componente : null,
        idCupo && idCupo > 0 ? idCupo : null,
        idAlumnoPrograma && idAlumnoPrograma > 0 ? idAlumnoPrograma : null,
        fechaDesde.length > 0 ? fechaDesde : null,
        fechaHasta.length > 0 ? fechaHasta : null,
        nivelEvento.length > 0 ? nivelEvento : null,
        descripcion.length > 0 ? descripcion : null,
      );
      if (newPage) {
        setCurrentPage(newPage);
      } else {
        setCurrentPage(1);
      }
      setEventos(newData.eventos);
      setTotalEventos(newData.totalCount);
    } catch (error) {
      toastError();
    }
    setLoading(false);
  };

  const loadInitialData = async () => {
    setLoading(true);
    await getTiposEventos();
    await getEventos();
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  return (
    <div className="eventosPage">
      <ModalConfirmation
        topBorderWarn
        show={showDeleteConfirmation}
        onClose={() => setShowDeleteConfirmation(false)}
        onConfirm={() => delEventos()}
        title="¿Desea eliminar todos los eventos registrados?"
      />
      <div className="filtersContainer">
        <div className="flex flex-row gap-4 items-stretch">
          <div className="flex-1 min-w-0 flex flex-wrap items-end gap-x-3 gap-y-2">
            <div className="filterField w-44">
              <span className="filterLabel">Tipo de evento</span>
              <Selector
                placeholder="Tipo de evento"
                options={tiposEventos}
                className="w-full"
                onSelect={(value) => setTipoEvento(value)}
                value={tipoEvento}
              />
            </div>
            <div className="filterField w-44">
              <span className="filterLabel">Nivel de evento</span>
              <Selector
                placeholder="Nivel de evento"
                options={nivelEventosOptions}
                className="w-full"
                onSelect={(value) => setNivelEvento(value)}
                value={nivelEvento}
              />
            </div>
            <div className="filterField w-24">
              <span className="filterLabel">idTx</span>
              <Input
                placeholder="idTx"
                value={idTx}
                onChange={(idTx) => setIdTx(idTx)}
                type="number"
              />
            </div>
            <div className="filterField w-36">
              <span className="filterLabel">Componente</span>
              <Input
                placeholder="Componente"
                value={componente}
                onChange={(componente) =>
                  setComponente(componente.toUpperCase())
                }
                type="text"
              />
            </div>
            <div className="filterField w-24">
              <span className="filterLabel">idCupo</span>
              <Input
                placeholder="idCupo"
                value={String(idCupo)}
                onChange={(idCupo) => setIdCupo(Number(idCupo))}
                type="number"
              />
            </div>
            <div className="filterField w-48">
              <span className="filterLabel">idAlumnoPrograma</span>
              <Input
                placeholder="idAlumnoPrograma"
                value={String(idAlumnoPrograma)}
                onChange={(idAlumnoPrograma) =>
                  setIdAlumnoPrograma(Number(idAlumnoPrograma))
                }
                type="number"
              />
            </div>
            {/* Flex break: fuerza que las dos fechas queden juntas en la siguiente fila */}
            <div className="basis-full h-0" aria-hidden="true" />
            <DateTimePicker
              label="Fecha desde"
              value={fechaDesde}
              onChange={setFechaDesde}
            />
            <DateTimePicker
              label="Fecha hasta"
              value={fechaHasta}
              onChange={setFechaHasta}
              defaultTime="23:59"
            />
            <div className="filterField flex-1 min-w-[180px]">
              <span className="filterLabel">Descripción</span>
              <Input
                placeholder="Descripción del evento"
                value={descripcion}
                onChange={(value) => setDescripcion(value)}
                type="text"
              />
            </div>
            <div className="filterField w-24">
              <span className="filterLabel">Por página</span>
              <Input
                placeholder="Cantidad"
                value={pageSize}
                onChange={(value) => {
                  const numValue = parseInt(value);
                  if (!isNaN(numValue) && numValue > 0) {
                    setPageSize(value);
                  }
                }}
                type="number"
              />
            </div>
            <div className="flex flex-row items-end gap-2 ml-auto">
              <Button
                label="Limpiar"
                theme="default"
                iconName="eraser"
                onClick={limpiarFiltros}
              />
              <Button
                label="Actualizar"
                iconName="search"
                onClick={() => getEventos()}
                disabled={!hasPermission("eventos", "actualizar_lista")}
              />
            </div>
          </div>
          <div className="actionsColumn">
            <Button
              label="Borrar todo"
              iconName="trash"
              onClick={() => setShowDeleteConfirmation(true)}
              theme="red"
              disabled={!hasPermission("eventos", "borrar_todo")}
            />
            <Button
              label="Exportar XLS"
              iconName="download"
              onClick={() => exportEventos()}
              theme="green"
              disabled={!hasPermission("eventos", "exportar_a_xls")}
            />
          </div>
        </div>
      </div>
      <div className="tableSection">
        <div className="tableListCont">
          <TableList
            list={eventos}
            enableSearchbar
            defaultWidthGeneral={180}
            page="eventos"
          />
        </div>
        <div className="paginationWrapper">
          <Pagination
            onPageChange={getEventos}
            currentPage={currentPage}
            totalCount={totalEvents}
            pageSize={Number(pageSize)}
          />
        </div>
      </div>
    </div>
  );
}

export default Log;
